export default {
  header: 'Wybierz menu',
  open_now: 'Teraz otwarte',
};
